module.exports = __webpack_public_path__ + "banquet/components/AccountSettings/images/push_toggle.a49f8bb170c6aea16be5f2280af1f05c.svg";


//////////////////
// WEBPACK FOOTER
// ./banquet/components/AccountSettings/images/push_toggle.svg
// module id = 1644
// module chunks = 1